/**
 * @auth 赖传峰
 * @date 2022/3/14
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

const category = 'web_yunpan_public_module'

const actions = {
  web_yunpan_cookie_tips_show(_: { current_address: string }) {},
  web_yunpan_cookie_tips_click(_: { current_address: string; button: 'accept' | 'manage' }) {},
  web_yunpan_cookie_pop_click(_: {
    current_address: string
    button: 'save' | 'close' | 'open_third_analysis' | 'close_third_analysis' | 'privacy_policy'
  }) {},
  web_yunpan_block_page_show(_: { current_address: string; page_path: string; share_id?: string }) {},
  click_language_guide_switch(_: { current_address: string; before_language: string; after_language: string }) {},
  /**
   * 云盘公共侧边栏点击
   * button：按钮，new-新建按钮，all-全部文件Tab，recent-最近添加，trash-回收站，storage_details-空间详情，premium_page-会员页面
   */
  web_public_module_sidebar_click(_: { button: 'new' | 'storage_details' | 'premium_page' }) {},
  /**
  /**
   * 传播页面运营位展示
   * scene：场景
   * - share_page - 文件分享页
   * - invitation_page - 邀请发起页面
   * - invited_page - 被邀请页面
   */
  spread_page_operation_show(_: { scene: 'share_page' | 'invitation_page' | 'invited_page' }) {},
  // 传播页面运营位点击
  spread_page_operation_click(_: { scene: 'share_page' | 'invitation_page' | 'invited_page' }) {},
}
export default new Proxy(actions, {
  get(target, key: keyof typeof actions) {
    return (data: Parameters<(typeof target)[typeof key]>[number]) => window.stat(category, key, data)
  },
})
